import { mdiChartPie } from '@mdi/js'

export default {
  title: 'Dashboard Admin',
  icon: mdiChartPie,
  resource: 'DashboardAdmin',
  action: 'read',
  to: 'dashboard-admin',
}
